import {connect} from 'react-redux';
import * as customers from 'customers/actions/customers';
import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Button, Form, FormGroup, Input, Label} from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import {withRouter} from 'react-router';

@connect(
    state => {
        return {
            customers: state.customers,
        }
    },
    dispatch => {
        return {
            add: (customer, history) => {
                dispatch(customers.add(customer, history))
            }
        }
    }
)
@withRouter
export default class NewCustomer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isNewCustomerModalOpen: false,
            newCustomer: {
                location_of: props.customer ? props.customer.id : null,
                name: ''
            }
        }
    }


    @autobind
    toggleNewCustomerModal() {
        this.setState(
            {
                ...this.state,
                isNewCustomerModalOpen: !this.state.isNewCustomerModalOpen
            }
        )
    }

    @autobind
    handleInput(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState(
            {
                ...this.state,
                newCustomer: {
                    ...this.state.newCustomer,
                    [name]: value
                }
            }
        )
    }

    @autobind
    confirmNewCustomer() {
        const history = this.props.history;
        this.props.add(this.state.newCustomer, history);
        this.toggleNewCustomerModal()
    }

    render() {
        return (
            <Fragment>
                <Button color="primary" onClick={this.toggleNewCustomerModal}>
                    Neuen Kunden anlegen
                </Button>
                <Dialog
                    isOpen={this.state.isNewCustomerModalOpen}
                    toggle={this.toggleNewCustomerModal}
                    confirm={this.confirmNewCustomer}
                    title={'Kunden anlegen'}
                >
                    <Form>
                        <FormGroup>
                            <Label>
                                Name
                            </Label>
                            <Input value={this.state.newCustomer.name} name='name'
                                   onChange={this.handleInput}/>
                        </FormGroup>
                    </Form>
                </Dialog>
            </Fragment>
        )
    }
}